import $ from "jquery";

class SiteVisitProblemReports {
    constructor(){
        $(document).on('turbo:load', function () {
            if ($('body').data('rails-controller') === 'service_visits') {
                $(document).on('change', '#trouble_ticket_state_id', function () {
                    $(this).closest('form')[0].requestSubmit();
                })
            }
        })
    }
}

export {SiteVisitProblemReports};
